const IMAGE_TYPES = ['image/jpeg', 'image/png', 'image/jpg'] as const;

type ImageMimeType = (typeof IMAGE_TYPES)[number];

type ImageFile = File & {
  type: ImageMimeType;
};

export const isImageFile = (file: File): file is ImageFile => {
  return IMAGE_TYPES.includes(file.type as ImageMimeType);
};
